import useAxiosPrivate from '../hooks/useAxiosPrivate';

export default function DeleteAllUsersFromBin({ setUsers }) {

  const axiosPrivate = useAxiosPrivate()

  //URL

  const DELETE_URL = '/users/delete/all';

  //Delete  function


  const deleteAllInactiveUsers = async () => {
    try {
      axiosPrivate.delete(DELETE_URL, {})
        .then(setUsers([]))
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <div>
      <button
        type="button"
        className="btn btn-danger"
        data-dismiss="modal"
        onClick={() => deleteAllInactiveUsers()}
      >Empty recycling bin</button>
    </div>

  )
}